import React from "react";
import { Skeleton, Stack } from "@chakra-ui/react";
import RiskReviewPanel from "./RiskReviewPanel";

const RiskReviewLoadingState = ({ rows = 6 }) => (
  <RiskReviewPanel>
    <Stack spacing={3}>
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton key={index} height={index === 0 ? "44px" : "34px"} borderRadius="md" />
      ))}
    </Stack>
  </RiskReviewPanel>
);

export default RiskReviewLoadingState;
